import React from '../vendor/react';
import { ArrowLeft } from '../vendor/lucide-react';
import { Link } from '../vendor/react-router-dom';
import { BrandMark } from '../components/layout/BrandMark';
import { Button } from '../components/ui/Button';

export function NotFoundPage() {
  return <main className="not-found"><BrandMark /><span>404</span><h1>Esta ruta no existe.</h1><p>Regresa a la aplicación para continuar.</p><Link to="/app"><Button icon={<ArrowLeft size={17} />}>Ir al resumen</Button></Link></main>;
}
